export const en = {
  videoQualityPresets: "Presets",
  prods: "Beats",
  stayInformed: "Stay informed",
  email: "E-mail",
  send: "Send",
  backToHome: "← Back to home",
  copyright: "© Hickssama 2021–2025 || support@hickssama.com",
  language: "Language",
  english: "English",
  french: "French",
  introGreeting: "Hi, I’m Hickssama. Welcome to my website!",
  introProfileAlt: "My profile photo",
  introPresetsDesc: "Here you can find my presets to create videos and edits with the same quality and effects I use.",
  introProdsDesc: "You’ll also find some beats I’ve made that feature in a few of my videos.",
  followMe: "Follow me on socials if you haven’t already, and sign up for the mailing list to stay updated. Feel free to reach out on Instagram or by email at support@hickssama.com."
};